exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-prepare-js": () => import("./../../../src/pages/prepare.js" /* webpackChunkName: "component---src-pages-prepare-js" */),
  "component---src-pages-print-test-js": () => import("./../../../src/pages/PrintTest.js" /* webpackChunkName: "component---src-pages-print-test-js" */)
}

